import { render } from "./Careers.vue?vue&type=template&id=2d5b94ed"
import script from "./Careers.vue?vue&type=script&lang=js"
export * from "./Careers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__